<section>
  <div class="row">
    <div class="col-md-9 col-lg-9">
      <div class="d-flex">
        <div>
          <h4 class="text-white mb-0"><b>POS Reports</b></h4>
          <p class="text-white m-0">
            {{ filters.reportType }}
            <small
              ><strong>({{ valueList.length }})</strong></small
            >
          </p>
        </div>
        <div class="form-group ml-3 w-c-50">
          <!-- <select id="selected_report" class="custom-select" name="selectedReport"
                        [(ngModel)]="filters.selectedReport" (ngModelChange)="updateRouterParams()">   
                        <option value="ENT">ENT</option>
                        <option value="HDC">HDC</option>
                        <option value="OWN">OWN</option>
                        <option value="OC">OC</option>
                        <option value="VOID">VOID</option>
                        <option value="Check duration">Check duration</option>
                        <option value="discount">Discount</option>
                    </select> -->
          <select
            id="my-select2"
            [(ngModel)]="filters.reportType"
            (ngModelChange)="onreportTypeChange($event)"
            class="custom-select"
            name=""
          >
            <option value="" disabled>Select</option>
            <option *ngFor="let item of reportTypeList" [value]="item?.name">
              {{ item?.name }}
            </option>
          </select>
        </div>
        <div class="form-group ml-3">
          <div class="input-container">
            <input
              type="date"
              id="selectedDate"
              class="form-control"
              [(ngModel)]="selectedDate"
              (ngModelChange)="handleDateChange()"
              [min]="minDate"
              [max]="maxDate"
              (keydown)="onKeyDown($event)"
              (focus)="openDatePicker($event)"
            />
            <!-- <i class="ri-calendar-line" placement="top" (click)="openDatePicker($event)" ngbTooltip="Select Date"></i> -->
          </div>
        </div>
        <div
          class="form-group ml-3 w-c-50"
          *ngIf="filters.reportType === 'Check Duration Report'"
        >
          <select
            id="my-select2"
            [(ngModel)]="filters.timePeriod"
            (ngModelChange)="updateFilter($event)"
            class="custom-select"
            name="timeperiod"
          >
            <option value="Check Duration Report">All</option>
            <option value="lessthan20mins">Less Than 20 Mins</option>
            <option value="morethan2hours">More Than 2 Hours</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 text-right">
      <button
        class="btn btn-primary btn-sm mr-2 py-1"
        (click)="uploadExcelFile(excelUpload)"
        [disabled]="valueList.length"
        [class.disabled]="valueList.length"
      >
        Upload
      </button>
      <button
        class="btn btn-primary btn-sm mr-2 py-1"
        (click)="export_report()"
        [disabled]="!valueList.length"
        [class.disabled]="!valueList.length"
      >
        Export
      </button>
    </div>
  </div>

  <!-- <section class="pos-reports-table">
        <div class="card">
            <div class="card-body p-0">
                <div class="table-responsive bg-white">
                    <table class="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>S no.</th>
                                <th>American Express</th>
                                <th>Authorizing Employee</th>
                                <th>Business Date</th>
                                <th>Cash</th>
                                <th>Check Duration</th>
                                <th>Check Employee</th>
                                <th>Check Line Total</th>
                                <th>Check Number</th>
                                <th>Check Sub Total</th>
                                <th>Check Total</th>
                                <th>close Date Time</th>
                                <th>Company</th>
                                <th>Creation</th>
                                <th>Day Part Name</th>
                                <th>Discount Master Name</th>
                                <th>Discount Total</th>
                                <th>Discount Amount</th>
                                <th>Doc Status</th>
                                <th>Employee</th>
                                <th>Ent</th>
                                <th>Food</th>
                                <th>Idx</th>
                                <th>Line Count</th>
                                <th>Line Total</th>
                                <th>Master Card</th>
                                <th>Modified</th>
                                <th>Modified By</th>
                                <th>Name</th>
                                <th>No Of Guests</th>
                                <th>No Of Items</th>
                                <th>No Of Times printed</th>
                                <th>Officer Check</th>
                                <th>Open date</th>
                                <th>Open Date Time</th>
                                <th>Payment Amount</th>
                                <th>Pos Checks</th>
                                <th>Print Chknotralr</th>
                                <th>Reason Code</th>
                                <th>Reference Information Line 1</th>
                                <th>Report Line Total</th>
                                <th>Return Period</th>
                                <th>Revenue Center</th>
                                <th>Room Charge</th>
                                <th>Tax Total</th>
                                <th>Tender Type</th>
                                <th>Tip Total</th>
                                <th>Transaction Date</th>
                                <th>Transaction Employee</th>
                                <th>Transfer To Check Number</th>
                                <th>Visa</th>
                                <th>Voids Total</th>
                                <th>Wallet Pay</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of doctypedata; let i = index;"> 
                                <td>{{ i+1 }}</td>
                                <td>{{ item?.american_express }}</td>
                                <td>{{ item?.authorizing_employee }}</td>
                                <td>{{ item?.business_date }}</td>
                                <td>{{ item?.cash }}</td>
                                <td>{{ item?.check_duration }}</td>
                                <td>{{ item?.check_employee }}</td>
                                <td>{{ item?.check_line_total }}</td>
                                <td>{{ item?.check_number }}</td>
                                <td>{{ item?.check_subtotal }}</td>
                                <td>{{ item?.check_total }}</td>
                                <td>{{ item?.close_date_time }}</td>
                                <td>{{ item?.company }}</td>
                                <td>{{ item?.creation }}</td>
                                <td>{{ item?.day_part_name }}</td>
                                <td>{{ item?.discount_master_name }}</td>
                                <td>item?.discount_total</td>
                                <td>{{ item?.discounts_amount }}</td>
                                <td>{{ item?.docstatus }}</td>
                                <td>{{ item?.employee }}</td>
                                <td>{{ item?.ent }}</td>
                                <td>{{ item?.food }}</td>
                                <td>{{ item?.idx }}</td>
                                <td>{{ item?.line_count }}</td>
                                <td>{{ item?.line_total }}</td>
                                <td>{{ item?.mastercard }}</td>
                                <td>{{ item?.modified }}</td>
                                <td>{{ item?.modified_by }}</td>
                                <td>{{ item?.name }}</td>
                                <td>{{ item?.number_of_guests }}</td>
                                <td>{{ item?.number_of_items }}</td>
                                <td>{{ item?.number_of_times_printed }}</td>
                                <td>{{ item?.officer_check }}</td>
                                <td>{{ item?.open_date }}</td>
                                <td>{{ item?.open_date_time }}</td>
                                <td>{{ item?.payment_amount }}</td>
                                <td>{{ item?.pos_checks }}</td>
                                <td>{{ item?.print_chknotralr }}</td>
                                <td>{{ item?.reason_code }}</td>
                                <td>{{ item?.reference_information_line_1 }}</td>
                                <td>{{ item?.report_line_total }}</td>
                                <td>{{ item?.return_period }}</td>
                                <td>{{ item?.revenue_center }}</td>
                                <td>{{ item?.room_charge }}</td>
                                <td>{{ item?.tax_total }}</td>
                                <td>{{ item?.tender_type }}</td>
                                <td>{{ item?.tip_total }}</td>
                                <td>{{ item?.transaction_date }}</td>
                                <td>{{ item?.transaction_employee }}</td>
                                <td>{{ item?.transfer_to_check_number }}</td>
                                <td>{{ item?.visa }}</td>
                                <td>{{ item?.voids_total }}</td>
                                <td>{{ item?.wallet_pay }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>

    </section> -->
  <div class="card">
    <!-- <div id="datatable"></div> -->
    <!-- <div class="table-responsive">
            <table class="table-bordered">
                <thead>
                    <tr>
                        <th></th>
                        <th *ngFor="let item of colListXL;">
                            {{ item }}
                        </th>
                    </tr>
    
                </thead>
                <tbody>
                    <tr *ngFor="let item of valueList ; let idx = index;">
                        <td>{{ idx }}</td>
                        <td *ngFor="let each of item;">
                            {{ each }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="text-center py-3" *ngIf="!valueList.length">
                <h4>No Data Found</h4>
            </div>
        </div> -->
    <div class="table-responsive">
      <table class="table-bordered">
        <thead>
          <tr>
            <th></th>
            <ng-container *ngFor="let item of colListXL; let i = index">
              <th>
                <ng-container
                  *ngIf="i !== colListXL.length - 1; else actionsHeader"
                >
                  {{ item }}
                </ng-container>
              </th>
            </ng-container>
            <ng-template #actionsHeader>
              <th class="custom-td">Attachments</th>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          <!-- <tr *ngIf="valueList.length">
                        <td></td>
                        <td>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="ri-search-line"></i>
                                    </span>
                                </div>
                                <input #outlet [(ngModel)]="filters.search.outlet" (keyup)="onSearch.emit(filters)"
                                    (search)="onSearch.emit(filters)" type="search" (keyup.enter)="updateRouterParams()"
                                    class="form-control">
                                  
                            </div>
                        </td>
                        <td>
                            <div>
                                <select id="check_found" class="custom-select" [(ngModel)]="filters.search.check_found"
                                    (change)="onSearch.emit(filters)">
                                    <option value="" disabled>Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </td>
                    </tr>  -->
          <tr *ngFor="let item of valueList; let idx = index">
            <td>{{ idx + 1 }}</td>
            <ng-container *ngFor="let each of item; let i = index">
              <td>
                <ng-container *ngIf="i !== item.length - 1; else viewButton">
                  {{ each }}
                </ng-container>
              </td>
            </ng-container>
            <ng-template #viewButton>
              <td
                class="custom-td"
                *ngIf="item[item.length - 1]"
                style="border: none"
              >
                <button
                  class="view-btn"
                  (click)="viewFile(item[item.length - 1])"
                >
                  <strong>View</strong>
                </button>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </table>
      <div class="text-center py-3" *ngIf="!valueList.length">
        <h4>No Data Found</h4>
      </div>
    </div>
  </div>
  <ng-template #excelUpload let-modal>
    <div class="p-2">
      <div class="modal-header py-2">
        <div class="d-flex">
          <div>
            <h6 class="mr-3 mb-0" id="modal-basic-title">
              <strong>POS Uploads</strong>
            </h6>
            <div class="d-flex align-item-center max-width-70">
              <input
                type="date"
                id="selectedDate"
                class="form-control custom-calender"
                [(ngModel)]="selectedDate"
                (ngModelChange)="handleDateChange()"
                [min]="minDate"
                [max]="maxDate"
              />
              <i class="ri-arrow-down-s-line"></i>
            </div>
          </div>
          <div>
            <!-- <div class="form-group calendar ">
                            <input [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" class="form-control h-auto"
                                placeholder="Date" [(ngModel)]="filters.file_upload_date ">
                            <i class="ri-calendar-2-line ml-2"></i>
                            <span class="example-trigger" [owlDateTimeTrigger]="dt1">
                                <i class="ri-calendar-2-line ml-2"></i>
                            </span>
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                        </div>
                    </div> -->
          </div>
          <!-- <div class="row">
                   <div class="col-md-12">
                    <h5 class="mr-3" id="modal-basic-title"><strong>POS Uploads</strong></h5>
                   </div>
                  
                </div>
                <div class="row">
                    <div class="col-md-9">
                        <div class="form-group calendar ">
                            <input [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" class="form-control h-auto" placeholder="Date"  [(ngModel)]="filters.file_upload_date">
                            <i class="ri-calendar-2-line ml-2"></i>
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                           
                        </div>
                    </div>
                    
                </div> -->
          <button
            type="button"
            class="close custom-modal-close"
            aria-label="Close"
            (click)="modal.dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div>
          <div class="card custom-card">
            <div class="card-body py-2">
              <div class="row align-item-center">
                <div class="col-6">
                  <div class="d-flex align-item-center">
                    <img
                      src="/assets/images/xlsx.svg"
                      alt=""
                      class="xlsx-icon"
                    />
                    <div class="px-2">
                      <div class="d-flex">
                        <p class="font-weight-bold mb-0">Transaction Summary</p>
                        <!-- <p class=" tran_success_msg mx-2" *ngIf="transactionFileSuccess">
                                                    <i class="ri-checkbox-circle-fill"></i>
                                                    </p>
                                                <p class=" tran_error_msg mx-2" *ngIf="fileInp1?.files[0]&&!transactionFileSuccess ">
                                                    <i class="ri-close-circle-fill"></i>
                                                    </p> -->
                      </div>

                      <!-- <div class="file-name-preview ml-auto">{{ fileInp1?.files[0]?.name }}</div> -->
                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="fileInp1?.files?.length > 0"
                      >
                        {{ fileInp1?.files[0]?.name }}
                      </div>
                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="!fileInp1?.files?.length"
                      >
                        No file uploaded
                      </div>
                    </div>
                  </div>
                  <!-- <small>only {{ bulkFileType?.typeMsg }} files are accepted <br> <a
                                            href={{ bulkFileType?.fileType }}>Click here to download sample
                                            format</a></small> -->
                </div>
                <div class="col-6 align-self-center text-right">
                  <input
                    type="file"
                    accept=".xlsx"
                    (change)="
                      handleFileInput($event.target.files, 'transaction')
                    "
                    #fileInp1
                    hidden
                    name="invoice-doc-file-1"
                    id="invoice-doc-file-1"
                  />
                  <label
                    for="invoice-doc-file-1"
                    class="ml-auto d-block cursor-pointer text-center input-file-upload-btn mb-0"
                  >
                    <i class="ri-upload-2-line"></i>
                    {{ fileInp1?.files?.length ? "Change" : "Upload" }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card custom-card my-2">
            <div class="card-body py-2">
              <div class="row align-item-center">
                <div class="col-6">
                  <div class="d-flex align-item-center">
                    <img
                      src="/assets/images/csv.svg"
                      alt=""
                      class="xlsx-icon"
                    />
                    <div class="px-2">
                      <div class="d-flex">
                        <p class="font-weight-bold mb-0">Closed Checks</p>
                        <!-- <p class=" tran_success_msg mx-2" *ngIf="closedFileSuccess">
                                                    <i class="ri-checkbox-circle-fill"></i>
                                                </p>
                                                <p class=" tran_error_msg mx-2" *ngIf="fileInp2?.files[0]&&!closedFileSuccess">
                                                    <i class="ri-close-circle-fill"></i>
                                                    </p> -->
                      </div>

                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="fileInp2?.files?.length > 0"
                      >
                        {{ fileInp2?.files[0]?.name }}
                      </div>
                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="!fileInp2?.files?.length"
                      >
                        No file uploaded
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 align-self-center text-right">
                  <input
                    type="file"
                    accept=".csv"
                    (change)="handleFileInput($event.target.files, 'closed')"
                    #fileInp2
                    hidden
                    name="invoice-doc-file"
                    id="invoice-doc-file-2"
                  />
                  <label
                    for="invoice-doc-file-2"
                    class="ml-auto d-block cursor-pointer text-center input-file-upload-btn mb-0"
                  >
                    <i class="ri-upload-2-line"></i>
                    {{ fileInp2?.files?.length ? "Change" : "Upload" }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card custom-card">
            <div class="card-body py-2">
              <div class="row align-item-center">
                <div class="col-6">
                  <div class="d-flex align-item-center">
                    <img
                      src="/assets/images/xlsx.svg"
                      alt=""
                      class="xlsx-icon"
                    />
                    <div class="px-2">
                      <div class="d-flex">
                        <p class="font-weight-bold mb-0">Void Checks</p>
                        <!-- <p class=" tran_success_msg mx-2" *ngIf="voidFileSuccess">
                                                    <i class="ri-checkbox-circle-fill"></i>

                                                    </p>
                                                <p class=" tran_error_msg mx-2" *ngIf="fileInp3?.files[0] &&!voidFileSuccess">
                                                    <i class="ri-close-circle-fill"></i>
                                                    </p> -->
                      </div>

                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="fileInp3?.files?.length > 0"
                      >
                        {{ fileInp3?.files[0]?.name }}
                      </div>
                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="!fileInp3?.files?.length"
                      >
                        No file uploaded
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 align-self-center text-right">
                  <input
                    type="file"
                    accept=".xlsx"
                    (change)="handleFileInput($event.target.files, 'void')"
                    #fileInp3
                    hidden
                    name="invoice-doc-file-3"
                    id="invoice-doc-file-3"
                  />
                  <label
                    for="invoice-doc-file-3"
                    class="ml-auto d-block cursor-pointer text-center input-file-upload-btn mb-0"
                  >
                    <i class="ri-upload-2-line"></i>
                    {{ fileInp3?.files?.length ? "Change" : "Upload" }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card custom-card my-2">
            <div class="card-body py-2">
              <div class="row align-item-center">
                <div class="col-6">
                  <div class="d-flex align-item-center">
                    <img
                      src="/assets/images/csv.svg"
                      alt=""
                      class="xlsx-icon"
                    />
                    <div class="px-2">
                      <div class="d-flex">
                        <p class="font-weight-bold mb-0">Discount Checks</p>
                        <!-- <p class=" tran_success_msg mx-2" *ngIf="discountFileSuccess">
                                                    <i class="ri-checkbox-circle-fill"></i>
                                                </p>
                                                <p class=" tran_error_msg mx-2" *ngIf="fileInp4?.files[0]&&!discountFileSuccess">
                                                    <i class="ri-close-circle-fill"></i>
                                                    </p> -->
                      </div>

                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="fileInp4?.files?.length > 0"
                      >
                        {{ fileInp4?.files[0]?.name }}
                      </div>
                      <div
                        class="file-name-preview ml-auto"
                        *ngIf="!fileInp4?.files?.length"
                      >
                        No file uploaded
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 align-self-center text-right">
                  <input
                    type="file"
                    accept=".csv"
                    (change)="handleFileInput($event.target.files, 'discount')"
                    #fileInp4
                    hidden
                    name="invoice-doc-file"
                    id="invoice-doc-file-4"
                  />
                  <label
                    for="invoice-doc-file-4"
                    class="ml-auto d-block cursor-pointer text-center input-file-upload-btn mb-0"
                  >
                    <i class="ri-upload-2-line"></i>
                    {{ fileInp4?.files?.length ? "Change" : "Upload" }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-right">
            <button
              type="button"
              class="btn btn-outline-primary"
              (click)="modal.dismiss()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary ml-2"
              (click)="submit_all_files()"
              [disabled]="
                !fileInp1?.files[0] ||
                !fileInp2?.files[0] ||
                !fileInp3?.files[0] ||
                !fileInp4?.files[0]
              "
            >
              Submit
            </button>
            <!-- <button type="button" class="btn btn-primary ml-2" (click)="submit_all_files()"
                        [disabled]="!((fileInp1?.files[0] && fileInp2?.files[0] && fileInp3?.files[0] && fileInp4?.files[0]) && (transactionFileSuccess && discountFileSuccess && voidFileSuccess && closedFileSuccess))" >
                            Submit
                        </button> -->
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</section>
